import React from "react";

// Assets
import LogoRegalias from "../../assets/img/logo_regalias.png";
import Cordoba40Logo from "../../assets/img/cordoba_4_0.png";
import UnicordobaLogo from "../../assets/img/unicordoba_logo.png";
import GobernacionLogo from "../../assets/img/gobernacion_logo.png";
import ArquiConcretoLogo from "../../assets/img/arquiconcreto_logo.png";
import GlobalFenixLogo from "../../assets/img/global_fenix_logo_v2.png";
import GimbicLogo from "../../assets/img/gimbic_logo.png";
import AlcaldiaLogo from "../../assets/img/alcaldia_cerete_logo.png";
import FoundationLogo from "../../assets/img/foundation_logo.png";

const LogosFooter = () => {
    return (
        <div className="container-fluid mb-4" style={{ marginTop: "20px" }}>
            <h5 className="text-center fw-bold mb-3" style={{ color: "#3E2723", textTransform: 'uppercase', letterSpacing: '2px', fontSize: '0.9rem' }}>
                Entidades Participantes
            </h5>
            <div className="d-flex flex-wrap justify-content-between align-items-center bg-white py-4 shadow-sm rounded-3 px-5">

                <div className="px-2"><img src={LogoRegalias} alt="Sistema General de Regalías" style={{ height: '70px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={Cordoba40Logo} alt="Córdoba 4.0" style={{ height: '70px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={UnicordobaLogo} alt="Universidad de Córdoba" style={{ height: '70px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={GobernacionLogo} alt="Gobernación de Córdoba" style={{ height: '75px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={ArquiConcretoLogo} alt="ArquiConcreto" style={{ height: '60px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={GlobalFenixLogo} alt="Global Fenix" style={{ height: '65px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={GimbicLogo} alt="GIMBIC" style={{ height: '60px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={AlcaldiaLogo} alt="Alcaldía de Cereté" style={{ height: '65px', objectFit: 'contain' }} /></div>
                <div className="vr d-none d-md-block mx-3" style={{ height: '40px', backgroundColor: '#e0e0e0', width: '2px', opacity: 1 }}></div>

                <div className="px-2"><img src={FoundationLogo} alt="Environment & Technology Foundation" style={{ height: '70px', objectFit: 'contain' }} /></div>

            </div>
        </div>
    );
};




export default LogosFooter;
